import { useQuery } from "@tanstack/react-query";
import { approvalApi } from "./api";

export function useApprovals(page = 0, size = 10) {
  return useQuery({
    queryKey: ["approvals", page, size],
    queryFn: () => approvalApi.list(page, size),
    staleTime: 1000 * 30,
  });
}